import { render, staticRenderFns } from "./DocumentGroup.vue?vue&type=template&id=79566a58&scoped=true"
import script from "./DocumentGroup.vue?vue&type=script&lang=js"
export * from "./DocumentGroup.vue?vue&type=script&lang=js"
import style0 from "./DocumentGroup.vue?vue&type=style&index=0&id=79566a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79566a58",
  null
  
)

export default component.exports